import { Component, Input, OnInit, SimpleChanges,OnChanges } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,HttpErrorResponse } from '@angular/common/http';
import 'rxjs/add/operator/map';
import { ActivatedRoute, Router } from '@angular/router';

import { LocalStorageService } from 'ngx-webstorage';
import { ToastrService } from 'ngx-toastr';
import { NgxSpinnerService } from "ngx-spinner";

import { DtoService } from '../../services/dto.service';
import { UtilService } from '../../services/util.service';
import { FunctService } from '../../services/funct.service';
import { TranslateService } from '@ngx-translate/core';
import { catchError, retry } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { Location } from '@angular/common';
import { CommonService } from '../../services/common.service';
import { ThrowStmt } from '@angular/compiler';

@Component({
  selector: 'app-account-login',
  templateUrl: './account-login.component.html',
  styleUrls: ['./account-login.component.scss']
})
  
export class AccountLoginComponent implements OnInit, OnChanges  {

  @Input() parentLink: string;
  token: any;
  userProfileModel: any;
  //isUserLoggedIn: any;
  showAmount: boolean = true;
  showBalance: any;
  deviceId: any;
  loadingBalance: boolean;

  routerName: any;
  providerId: any = 5 // default JILI;
  @Input() isUserLoggedIn?: boolean; 
  constructor(
    private translateService: TranslateService,
    private toastr: ToastrService,
    private spinner: NgxSpinnerService,
    private dto: DtoService,
    private http: HttpClient,
    private util: UtilService, 
    private route: ActivatedRoute,
    private router: Router,
    private storage: LocalStorageService,
    private funct: FunctService,
    private location: Location,
    public common: CommonService) { 

      this.routerName = this.router.url;
      if (this.isUserLoggedIn === undefined)
      {
        this.isUserLoggedIn = this.storage.retrieve('isUserLoggedIn');
      }
      this.deviceId = this.storage.retrieve('localDeviceId');  
      this.showAmount = this.storage.retrieve('showAmount');
    
      this.token = this.storage.retrieve('token'); 
      
      if (this.token == null) {
        this.storage.store('token', '');       
        this.storage.store('isUserLoggedIn', false);
      }
    
      if (this.storage.retrieve('localShowBalance') == null) {
        this.storage.store('localShowBalance', true); 
      }
      
  }

  async ngOnChanges(changes: SimpleChanges): Promise<void> {
      if (changes.isUserLoggedIn?.currentValue)
    {
      const token = await this.storage.retrieve('token');
      this.isUserLoggedIn = changes.isUserLoggedIn.currentValue;
    }
  }
  ngOnInit(): void {

    this.userProfileModel = {
      balance: '',
      imageUrl: '',
      name: '',
      phone_no: '',
      referral_code: ''
    }
    if (this.isUserLoggedIn) this.getUserProfile();
     
  }
  
  login() {
    this.storage.clear('fromBtnClicked');
    this.router.navigate(['/auth/welcome'], { replaceUrl: false });
  }

  goToProfileDetail() {
    this.router.navigate(['/profile/detail'], { replaceUrl: false });
  }

  handleError(error: HttpErrorResponse){
    if (error.status == 0) {
      this.common.errorMsg("", "checkInternet", "top");
    }
    if (error.status == 423 || error.status == 417) {
      this.common.errorMsg("", "youNeedLogin", "top");
      this.storage.store('token', '');
      this.storage.store('isUserLoggedIn', false);
    }
    if (error.status == 400) {
      this.common.errorMsg("", "bad_request", "top");
    }
    return throwError(error);
  }
  
  getUserProfile() {
  
    this.token = this.storage.retrieve('token');
    let headers = new HttpHeaders();
    headers = headers.set('Authorization', this.token);

    this.loadingBalance = true;
    this.spinner.show("balanceLoading");
    this.http.get(this.funct.ipaddress + 'user/PointUserProfile', { headers: headers })
    .pipe(
      catchError(this.handleError.bind(this))
    )
    .subscribe(
      result => {
        this.dto.Response = {};
        this.dto.Response = result;
        this.userProfileModel = this.dto.Response; 
        this.showBalance = this.userProfileModel.balance;
        this.storage.store("userProfile",this.userProfileModel);//to test
        this.loadingBalance = false;
        this.spinner.hide("balanceLoading");
    });
    
  }

  toggleAmount(show: boolean) {
    this.showAmount = show;
    this.storage.store('showAmount', show);
    this.storage.store('localShowBalance', this.showAmount);
  }

  goToTopup() {
    this.router.navigate(['/wallet/top-up'],{replaceUrl:false});
  }

  goToHistory(){
    this.storage.clear('localHistoryDetail');
    this.router.navigate(['/wallet/history'],{replaceUrl:false});
  }

  selectGameListId() { 
    var localGameProviderList = this.storage.retrieve("localGameProviderList");
    var objProvider = localGameProviderList.find(x => x.isMaintenance  && x.provider_id == this.providerId);
    if(objProvider != undefined)
    {
      var providerName = objProvider.display_name;
      this.common.errorMsg("", "", "top", providerName + this.translateService.instant("undermaintenance"));
      return;
    }
    else
    {
    this.router.navigate(['/game/wallet'], {state: {selectGameAccount: this.providerId, parentLink: "/gameList/"+this.providerId},replaceUrl: false});
    }
  }

}
